export default __webpack_public_path__ + "static/media/ubereats.defb6e6a.svg";